import { defineStore } from 'pinia';

export const useTableVisibleColumnsStore = defineStore('tableVisibleColumns', {
  state: (): { visibleColumns: Record<string, string[]> } => ({
    visibleColumns: {},
  }),
  actions: {
    setVisibleColumns(dataKey: string, columns: string[]) {
      this.visibleColumns[dataKey] = columns;
    },
    getVisibleColumns(dataKey: string) {
      return this.visibleColumns[dataKey] || [];
    },
  },
  persist: {
    storage: localStorage,
  },
});
